import React, { useEffect, useState } from 'react';
import { BellRing, Loader2, Send } from 'lucide-react';
import { toast } from 'sonner';
import { api, errMsg } from '../api';
import { Card, goldBtn, ghostBtn } from '../ui';
import { currentSubscription, enablePush, pushSupported } from '../../lib/push';

export default function PushCard() {
  const [on, setOn] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => { currentSubscription().then((s) => setOn(!!s && Notification.permission === 'granted')).catch(() => {}); }, []);
  const enable = async () => {
    setBusy(true);
    try { await enablePush((sub) => api.post('/push/subscribe', sub)); setOn(true); toast.success('Notifiche attive su questo dispositivo'); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const disable = async () => {
    const s = await currentSubscription();
    if (s) { await api.post('/push/unsubscribe', s.toJSON()).catch(() => {}); await s.unsubscribe(); }
    setOn(false); toast.success('Notifiche disattivate su questo dispositivo');
  };
  const test = () => api.post('/push/test').then(() => toast.success('Notifica di prova inviata')).catch((e) => toast.error(errMsg(e)));
  return (
    <Card className="p-8 mt-6" data-testid="push-card">
      <h2 className="font-heading text-lg mb-2 inline-flex items-center gap-2"><BellRing size={18} className="text-[#D4AF37]" />Notifiche sul telefono</h2>
      <p className="text-sm text-[#A3A3A3] mb-5 max-w-2xl">Ricevi sull'app BOND un avviso quando arriva l'esito di una pratica, una nuova segnalazione whistleblowing (solo per i gestori designati) o un allarme Travel Security: rischio in aumento, evento grave, arrivo non confermato, richiesta di emergenza di un viaggiatore. Su iPhone installa prima l'app dalla schermata Home.</p>
      {!pushSupported() && <p className="text-sm text-[#E0A04A] mb-3" data-testid="push-unsupported">Questo browser non supporta le notifiche: apri BOND dall'app installata.</p>}
      <div className="flex flex-wrap gap-3">
        {on
          ? <><span className="text-sm text-[#5FC18F] self-center" data-testid="push-status-on">Attive su questo dispositivo</span>
            <button onClick={test} className={`${ghostBtn} h-10 px-4 text-sm inline-flex items-center gap-2`} data-testid="push-test-btn"><Send size={14} />Invia prova</button>
            <button onClick={disable} className={`${ghostBtn} h-10 px-4 text-sm`} data-testid="push-disable-btn">Disattiva</button></>
          : <button onClick={enable} disabled={busy} className={`${goldBtn} h-10 px-5 text-sm inline-flex items-center gap-2`} data-testid="push-enable-btn">{busy ? <Loader2 size={14} className="animate-spin" /> : <BellRing size={14} />}Attiva le notifiche</button>}
      </div>
    </Card>
  );
}
